import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';

import paymentConstants from '../constants/payment-constants';

import '../styles/payment-history-table.css';

class PaymentHistoryTable extends Component {
  formatPaymentStatus(status) {
    for (var key in paymentConstants.payment_statuses) {
      if (paymentConstants.payment_statuses[key].value === status) {
        return paymentConstants.payment_statuses[key].label;
      }
    }

    return '';
  }

  renderTableBody(payments) {
    if (payments && payments.length > 0) {
      return payments.map((payment, index) => {
        return (
          <tr className="payment-history-table-container__table__body__row" key={index}>
            <td>{payment.creation_date ? moment(payment.creation_date).format('DD/MM/YYYY') : ''}</td>
            <td>
              <span className={`status status-${payment.status ? payment.status.toLowerCase() : ''}`}>{this.formatPaymentStatus(payment.status)}</span>
            </td>
            <td>{`$${payment.amount}`}</td>
          </tr>
        );
      });
    } else return null;
  }

  render() {
    const { t } = this.context;
    const { payments } = this.props;

    return (
      <div className="payment-history-table-container">
        <table className="payment-history-table-container__table">
          <thead className="payment-history-table-container__table__head">
            <tr className="payment-history-table-container__table__head__row">
              <th>{t('PAYMENTS.DATE_COLUMN')}</th>
              <th>{t('PAYMENTS.STATUS_COLUMN')}</th>
              <th>{t('PAYMENTS.AMOUNT_COLUMN')}</th>
            </tr>
          </thead>
          <tbody className="payment-history-table-container__table__body">{this.renderTableBody(payments)}</tbody>
        </table>
      </div>
    );
  }
}

PaymentHistoryTable.contextTypes = {
  t: PropTypes.func.isRequired,
};

export default PaymentHistoryTable;



// WEBPACK FOOTER //
// ./src/app/main/payments/components/payment-history-table.js